import { RegtankOnboardingStatusEnum } from "../constant/enum";

const isFinalOnboardingLink = (
  onboardingStatus: RegtankOnboardingStatusEnum
) => {
  if (
    onboardingStatus !== RegtankOnboardingStatusEnum.APPROVED &&
    onboardingStatus !== RegtankOnboardingStatusEnum.REJECTED &&
    onboardingStatus !== RegtankOnboardingStatusEnum.EXPIRED
  ) {
    return false;
  }
  return true;
};

export const checkIsExpired = (expiredDate: string) => {
  const parsedExpiredDate = expiredDate.replace(" ", "T") + "Z";
  return parsedExpiredDate <= new Date().toISOString();
};

export const checkOnboardingLinkValid = (
  onboardingStatus: RegtankOnboardingStatusEnum,
  expiredDate: string
) => {
  if (!isFinalOnboardingLink(onboardingStatus) && !checkIsExpired(expiredDate))
    return true;
  return false;
};

/**
 * Converts Date or string to ISO string format
 */
export const toISOString = (date: string | Date | undefined): string => {
  if (!date) return "";
  return typeof date === "string" ? date : date.toISOString();
};

/**
 * Sorts data by expiredDate in descending order
 * Handles both string and Date object types
 */
export const sortRegtankRequestsByExpiry = (data: any[]): any[] => {
  const sorted = [...data];
  if (sorted.length <= 1) return sorted;
  if (typeof sorted[0]?.expiredDate === "string") {
    return sorted.sort(
      (a, b) =>
        new Date(b.expiredDate).getTime() - new Date(a.expiredDate).getTime()
    );
  }
  return sorted.sort(
    (a, b) => b.expiredDate.getTime() - a.expiredDate.getTime()
  );
};
